// src/hooks/nationalities/useUpdateNationalities.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateNationality } from "../../api/apiNationalities";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useUpdateNationalities = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: editNationalities, isPending: isUpdate } = useMutation({
        mutationFn: ({ id, req }) => updateNationality(req, id),
        onSuccess: (res) => {
            const message = res?.message || "Nationality updated successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["nationalities"] });
            queryClient.invalidateQueries({ queryKey: ["nationality"] });
            navigate("/nationalities");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to update nationality");
        },
    });

    return { editNationalities, isUpdate };
};

export default useUpdateNationalities;